import {useQuery} from "@tanstack/react-query"
import axios from "axios"
import {VersionLogSearchResult} from "../types/VersionLog";

interface UseVersionLogListQueryProps {
    page: number
    perPage: number
    companyAutomationId: number
}
export default function useVersionLogListQuery({
    page,
    perPage,
    companyAutomationId,
}: UseVersionLogListQueryProps) {
    return useQuery({
        queryKey: ['versionLog', companyAutomationId, page, perPage],
        queryFn: async () => {
            const GET_VERSION_LOG_ENDPOINT = `/admin/action/automation/admin/getVersionLogs/${companyAutomationId}`;
            const { data } = await axios.get(GET_VERSION_LOG_ENDPOINT, {
                params: {
                    page: page,
                    count: perPage,
                }
            })
            return {
                nodes: data.VERSION_LOG.results.map((el : any) => {
                    return el;
                }) as Array<VersionLogSearchResult>,
                totalCount: data.VERSION_LOG.totalCount,
            }
        },
    })
}